import { render } from "./Hero.vue?vue&type=template&id=6508a86d&scoped=true"
import script from "./Hero.vue?vue&type=script&lang=js"
export * from "./Hero.vue?vue&type=script&lang=js"

import "./Hero.vue?vue&type=style&index=0&id=6508a86d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6508a86d"]])

export default __exports__